// initial
var ProductImageGallery = function () {

    var form;

    var Thumbnails = function () {

        const activeImage = form.querySelector(".product-image .active");
        const productImages = form.querySelectorAll(".image-list img");

        var items = Array.prototype.slice.call(form.querySelectorAll('.image-list .image-item'))

        function changeImage(e) {
            let source = e.target.src
            activeImage.src = source;

            var selected = e.target.closest('div')

            var index = items.indexOf(selected)

            activeImage.closest('div').setAttribute('data-start', index)


            $('.image-list img').removeClass('active')
            this.classList.add('active')
        }

        productImages.forEach(image => image.addEventListener("click", changeImage));

    }

    var Gallery = function () {

        $(form).on('click', '[data-elements]', function (event) {
            event.preventDefault();
            let elements = JSON.parse(this.getAttribute('data-elements'));

            const lightbox = GLightbox({
                elements: elements,
                autoplayVideos: true,
                zoomable: true,
                openEffect: "zoom",
                closeEffect: "fade",
                touchNavigation: true,
                keyboardNavigation: true,
                closeOnOutsideClick: true,
                startAt: this.getAttribute('data-start'),
            });
            lightbox.open();
        })

    }


    return {
        init: function () {
            form = document.querySelector('.product-page');
            if (!form) {
                return;
            }
            Thumbnails();
            Gallery();
        },
    };

}();




$(function () {
    ProductImageGallery.init();
});